import React, { useState, useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'

import * as ROUTES from '../../../routes'
import * as TYPES from './types'

import LoginModal from '../../../Modals/LoginModal'
import imgLogo from '../../../assets/logo.png'

import { withReduxAuth } from '../../../Redux/indexAuth'


const PublicHeader: React.FC<TYPES.PublicHeaderProps> = (props: TYPES.PublicHeaderProps) => {
    const { children, auth, showEALink, showLogin } = props;
    const location = useLocation();
    const [showLoginModal, setShowLoginModal] = useState(false);

    const handleBrandClick = (e: React.MouseEvent) => {
        if (location.pathname === ROUTES.PATH.LANDING) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const publicRoutes = [
            ROUTES.PATH.LANDING,
            ROUTES.PATH.EARLY_ACCESS,
            ROUTES.PATH.TERMS_OF_SERVICE,
            ROUTES.PATH.PRIVACY_POLICY,
        ];

        // Don't show modal if already on a public route
        const isOnPublicRoute = publicRoutes.some(route => location.pathname === route || location.pathname.startsWith(route + '/'));
        if (isOnPublicRoute) {
            setShowLoginModal(false);
            return;
        }

        const isProtectedRoute = (pathname: string): boolean => {
            const isPublicRoute = publicRoutes.some(route => pathname === route || pathname.startsWith(route + '/'));
            if (isPublicRoute) return false;
            
            // Match UUID or ID-based project routes: /:id/* or just /:id
            if (/^\/[a-zA-Z0-9\-_]+(?:\/|$)/.test(pathname)) {
                return true;
            }
            
            return false;
        };

        if (auth?.httpError?.length && location.pathname !== ROUTES.PATH.EARLY_ACCESS) {
            setShowLoginModal(true);
        } else if (isProtectedRoute(location.pathname) && !auth?.authToken) {
            setShowLoginModal(true);
        }
    }, [auth?.httpError, auth?.authToken, location.pathname]);

    return (
        <>
            <nav className="gn-public-header">
                <Link
                    to={ROUTES.PATH.LANDING}
                    className="brand-link"
                    onClick={handleBrandClick}
                >
                    <img
                        src={imgLogo}
                        alt="GameNostic Logo"
                        className="brand-image"
                        style={{opacity: '.8'}}
                    />
                    <span className="brand-text">&nbsp;GameNostic</span>
                </Link>
                {children}
                {(showLogin || showEALink) ? (<div className="gn-header-nav-spacer">
                    {showLogin && !auth?.authToken && (
                        <button className="gn-header-nav-btn-login" onClick={() => setShowLoginModal(true)}>
                            <svg className="gn-header-nav-btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
                                <path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.337 0-10 1.676-10 5v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-1c0-3.324-6.663-5-10-5z"/>
                            </svg>
                            <span className="gn-header-nav-btn-text">Log in</span>
                        </button>
                    )}
                    {showEALink && (
                        <Link className="gn-header-nav-btn-cta" to={ROUTES.PATH.EARLY_ACCESS}>
                            <svg className="gn-header-nav-btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
                                <path d="M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19M5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5M21.61 2.39C21.61 2.39 16.66 .269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39M14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46M8.88 16.53L7.47 15.12L8.88 16.53M6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L4.83 22H6.24M2 22H3.41L8.18 17.24L6.76 15.83L2 20.59V22M2 19.17L6.09 15.09C5.88 14.79 5.73 14.46 5.64 14.12L2 17.76V19.17Z"/>
                            </svg>
                            <span className="gn-header-nav-btn-text">Get Early Access ›</span>
                        </Link>
                    )}
                </div>) : null}
            </nav>
            <LoginModal show={showLoginModal} onHide={() => setShowLoginModal(false)} />
        </>
    );
}

export default withReduxAuth(PublicHeader)
